import React from "react";
import { Link } from "react-router-dom";

export const HomeServices = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            This option highlights the additional services beyond breeding,
            showcasing your commitment to the well-being of the dogs and their
            new families.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  {" "}
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
      <div style={{textAlign: "center", marginTop:"2em"}}>
      <Link
        to="/services"
        className="btn btn-custom btn-lg"
      >
        Learn More
      </Link>{" "}
      </div>
    </div>
  );
};
